/**
 * Anti-inspection guard — production only, lightweight version.
 * No debugger trap, no console override (those crash the app).
 */

const isProd = import.meta.env.PROD;

export function initAntiDevTools() {
  if (!isProd) return;

  // 1. Disable right-click context menu
  document.addEventListener('contextmenu', e => e.preventDefault());

  // 2. Block DevTools keyboard shortcuts
  document.addEventListener('keydown', e => {
    const ctrl = e.ctrlKey || e.metaKey;
    const shift = e.shiftKey;
    if (e.key === 'F12') { e.preventDefault(); return; }
    if (ctrl && shift && /^[ijcIJC]$/.test(e.key)) { e.preventDefault(); return; }
    if (ctrl && /^[uU]$/.test(e.key)) { e.preventDefault(); return; }
  });

  // 3. Console brand message (one-time, no override)
  setTimeout(() => {
    console.clear();
    console.log(
      '%c\u26D4 Stop!',
      'color:#ef4444;font-size:2rem;font-weight:900;'
    );
    console.log(
      '%cThis is a private application. Unauthorized inspection is prohibited.\n\u00a9 2026 Phanh \u2014 Ho\u00e0ng Phi Anh (Noland Hoang)',
      'color:#64748b;font-size:0.9rem;'
    );
  }, 1000);

  // 4. Disable text selection outside inputs
  document.addEventListener('selectstart', e => {
    const tag = e.target?.tagName || '';
    if (!['INPUT', 'TEXTAREA'].includes(tag)) e.preventDefault();
  });

  // 5. Disable drag
  document.addEventListener('dragstart', e => e.preventDefault());
}
